<template>
  <a-table
    :dataSource="dataSource"
    :columns="columns"
    class="mb40"
    :pagination="pagination"
  >
    <template v-slot:bodyCell="{ column, record }">
      <template v-if="column.dataIndex == 'imgUrl'">
        <a-image :width="100" :src="record.imgUrl"></a-image>
      </template>
      <template v-if="column.dataIndex == 'recommend'">
        <span v-if="record.recommend === 0">{{ '未推荐' }}</span>
        <span v-if="record.recommend === 1">{{ '推荐' }}</span>
      </template>
      <template v-if="column.dataIndex == 'operate'">
        <a-button type="link" @click="handleEdit(record)">
          编辑
        </a-button>
        <span v-if="record.recommend === 0">
          <a-popconfirm
            title="您确定要推荐吗"
            @confirm="handleRecommend(record)"
          >
            <a-button type="link">
              推荐
            </a-button>
          </a-popconfirm>
        </span>
        <span v-if="record.recommend === 1">
          <a-popconfirm
            title="您确定要结束当前推荐吗？"
            @confirm="handleRecommend(record)"
          >
            <a-button type="link">
              结束推荐
            </a-button>
          </a-popconfirm>
        </span>
        <a-popconfirm
          title="您确定要删除当前推荐吗？"
          @confirm="handleDel(record)"
        >
          <a-button type="link">
            删除
          </a-button>
        </a-popconfirm>
      </template>
    </template>
  </a-table>
</template>

<script>
import { inject, toRefs } from 'vue'
export default {
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>

<style lang="scss" scoped></style>
